import { createContext } from 'react'

import { ModalContext } from './types'

const Context = createContext<ModalContext>({
  closeModal: () => null
})

export default Context
